module.exports = __webpack_public_path__ + "img/ch37.42651380.jpg";